var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{staticClass:"section-title small-20 columns"},[_vm._v(_vm._s(_vm.configurations.itemTitle))]),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.allPosts),function(post,index){return _c('post',{key:post.id,attrs:{"postData":post,"index":index}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }